import { Section, ChromeHeading, GoldButton, OutlineGoldButton } from "../funnel";
import { EVENT_DAY_LABEL, EVENT_TIME_LABEL } from "../../config/event";
import { GOOGLE_CALENDAR_URL, OUTLOOK_CALENDAR_URL, ICS_URL, ICS_FILENAME } from "../../lib/calendar";
import { TELEGRAM_URL, CREDIT_REPORT_URL } from "../../config/links";

const EXT = { target: "_blank", rel: "noopener noreferrer" };

const Row = ({ n, title, body, children }) => (
  <li className="grid grid-cols-[auto_1fr] gap-x-5 py-9 sm:gap-x-10" data-testid={`next-step-${n}`}>
    <span className="font-display gold-text w-10 text-6xl leading-none sm:w-16 sm:text-7xl">{n}</span>
    <div className="min-w-0">
      <h3 className="text-xl font-semibold leading-snug text-[#f4efe4] sm:text-2xl">{title}</h3>
      <p className="mt-3 max-w-2xl text-[15px] leading-relaxed text-[#cfc7b6] sm:text-base">{body}</p>
      {children && <div className="mt-6">{children}</div>}
    </div>
  </li>
);

export const NextSteps = () => (
  <Section data-testid="next-steps-section">
    <ChromeHeading className="text-4xl sm:text-5xl lg:text-6xl">Your next steps</ChromeHeading>
    <ol className="mt-10 divide-y divide-[rgba(232,184,74,0.2)] border-y border-[rgba(232,184,74,0.2)]">
      <Row n="1" title="Join the free community" body="Reminders, the Zoom link and a place to drop your questions before class. My team is in there daily.">
        <GoldButton href={TELEGRAM_URL} className="w-full sm:w-auto" data-testid="registered-telegram-button">Join the Telegram community →</GoldButton>
      </Row>
      <Row n="2" title="Save the Zoom link to your calendar" body={`${EVENT_DAY_LABEL} at ${EVENT_TIME_LABEL} ET. Set two alarms: one the day before and one 15 minutes before.`}>
        <div className="grid grid-cols-3 gap-2 sm:flex sm:flex-wrap sm:gap-3">
          <OutlineGoldButton href={GOOGLE_CALENDAR_URL} {...EXT} className="px-2 sm:min-w-[104px] sm:px-5" data-testid="calendar-google-button">Google</OutlineGoldButton>
          <OutlineGoldButton href={ICS_URL} download={ICS_FILENAME} className="px-2 sm:min-w-[104px] sm:px-5" data-testid="calendar-apple-button">Apple</OutlineGoldButton>
          <OutlineGoldButton href={OUTLOOK_CALENDAR_URL} {...EXT} className="px-2 sm:min-w-[104px] sm:px-5" data-testid="calendar-outlook-button">Outlook</OutlineGoldButton>
        </div>
      </Row>
      <Row n="3" title="Pull your 3-bureau credit report before class" body="Get your Experian, Equifax and TransUnion reports and scores in one place, and have them open during class so you can follow along with your own file.">
        <OutlineGoldButton href={CREDIT_REPORT_URL} {...EXT} className="w-full sm:w-auto" data-testid="credit-report-button">Get my 3-bureau report →</OutlineGoldButton>
        <p className="mt-3 max-w-xl text-[12px] leading-relaxed text-[#8a857b]" data-testid="affiliate-disclosure">Affiliate link: J11 may earn a commission if you sign up. Free annual reports are also available at AnnualCreditReport.com.</p>
      </Row>
      <Row n="4" title="Show up live and stay to the end" body="Live attendees who stay through Q&A get the chance to ask about their own file." />
    </ol>
  </Section>
);
